import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { isUsMarket } from "utils/market";
import { queryKeys } from "utils/misc";
import { TemplateListItemDto } from "./templateDtos";
import { rolloutRefetchInterval } from "./catalogueDeployments";

export const useGetTemplates = () =>
  useQuery<TemplateListItemDto[]>(
    queryKeys.templates(),
    async () => {
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const data = await api.parse(`GET /treatments/schedules?locale=${isUsMarket ? "en-US" : "sv-SE"}`, {
        root: supportApiBase,
      });
      return Array.isArray(data) ? data : [];
    },
    { refetchInterval: data => rolloutRefetchInterval(data) }
  );
